module.exports = "/_next/static/2nd.png";